import { authHeader } from './auth-header';
import router from "../../router";
import { getCaptchaToken } from '../recaptcha';

export const userService = {
    login,
    logout,
    frontLogout
};

async function login(email, password) {

    const captchaToken = await getCaptchaToken('login');
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, captcha_token: captchaToken })
    };

    return fetch(process.env.VUE_APP_API_URL + `user/login`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.response.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                if (user.response.user_type_id !== 3 && user.response.user_type_id !== 4) {
                    localStorage.setItem('token', user.response.token);
                    localStorage.setItem('user', JSON.stringify(user.response));
                }
                if (user.response.user_type_id === 3 || user.response.user_type_id === 4) {
                    localStorage.setItem('web_user', JSON.stringify(user.response));
                }
                authHeader();
            }
            return user;
        });
}

function logout() {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('token') },
    };
    return fetch(process.env.VUE_APP_API_URL + `user/logout`, requestOptions)
        .then(handleResponse)
        .then(() => {
            var user = JSON.parse(localStorage.getItem('user'))
            var web_user = JSON.parse(localStorage.getItem('web_user'))
            if (user.user_type_id !== 3 && user.user_type_id !== 4) {
                localStorage.removeItem('user');
                localStorage.removeItem('token');
                router.push('/login');
            }
            if (web_user.user_type_id === 3 || user.user_type_id === 4) {
                localStorage.removeItem('web_user');
                router.push('/volunteer-system/login');
            }
        });
}

function frontLogout() {
    var web_user = JSON.parse(localStorage.getItem('web_user'))
    let token = web_user['token'];
    console.log(token);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
    };
    return fetch(process.env.VUE_APP_API_URL + `user/logout`, requestOptions)
        .then(handleResponse)
        .then(() => {
            if (web_user['user_type_id'] === 3 || web_user['user_type_id'] === 4) {
                localStorage.removeItem('web_user');
                router.push('/volunteer-system/login');
            }
        });
}



function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                var user = JSON.parse(localStorage.getItem('user'))
                var web_user = JSON.parse(localStorage.getItem('web_user'))
                if (user) {
                    if (user.user_type_id !== 3 && user.user_type_id !== 4) {
                        localStorage.removeItem('user');
                        localStorage.removeItem('token');
                        router.push('/login');
                    }
                }
                if (web_user) {
                    if (web_user.user_type_id === 3 || user.user_type_id === 4) {
                        localStorage.removeItem('web_user');
                        router.push('/volunteer-system/login');
                    }
                }
                logout();
                location.reload(true)
                // setTimeout(() => location.reload(true), 4000);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
